<div class="holder">
    <div class="buttonHolder" *ngIf="apiService.daysList && apiService.daysList.length">
        <div class="dayButtonsSlider" >
            <app-day-button *ngFor="let item of apiService.daysList | slice:0:14; let i = index" [date]="item.date" [isSelected]="item.id == apiService.getDayIDSelected()" (click)="selectDay(i)" [color1]="color1" [color2]="color2" [color3]="color3" [color4]="color4" [isFirst]="i==0" [isLast]="i==apiService.daysList.slice(0,14).length-1"></app-day-button>
        </div>
    </div>

    <div class="arrows">
        <app-arrow-left (click)="onLeft()"></app-arrow-left>
        <app-arrow-right (click)="onRight()"></app-arrow-right>
    </div>
</div>